import { useEffect, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useAppDispatch } from "../../utils/hooks";
import { listActiveSubscriptions } from "../../redux/actions/Subscription";
import { UserData } from "../../types/models/UserData";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";

function AdminIndex() {

    const dispatch = useAppDispatch();

    const [users, setUsers] = useState<UserData[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);


    useEffect(() => {
        setIsLoading(true);
        dispatch(listActiveSubscriptions((users) => {
            setUsers(users);
        }));
        setIsLoading(false);
    }, []);

    const columns = useMemo<GridColDef<UserData>[]>(
        () => [
            {field: 'id', headerName: 'User ID', flex: 0, minWidth: 300, renderCell: (params: any) => (
                <Box>
                {params.row.id}
                </Box>
            )},
            {field: 'email', headerName: 'Email', flex: 0, minWidth: 300, renderCell: (params: any) => (
                <Box>
                {params.row.email}
                </Box>
            )},
            {field: 'subscription', headerName: 'Subscription', flex: 0, minWidth: 350, renderCell: (params: any) => (
                <Box>
                {params.row.subscription}
                </Box>
            )},
            {field: 'activeExps', headerName: 'Active Experiences', flex: 1, renderCell: (params: any) => (
                <Box>
                {params.row.activeExps}
                </Box>
            )},
            {field: 'archivedExps', headerName: 'Archived Experiences', flex: 1, renderCell: (params: any) => (
                <Box>
                {params.row.archivedExps}
                </Box>
            )},
            {field: 'createdAt', headerName: 'Created At', flex: 2, renderCell: (params: any) => (
                <Box>
                {new Date(params.row.createdAt).toLocaleString()}
                </Box>
            )},
        ],
      [users],
      );

    return (
        <Box sx={{ padding: 4, height: "100vh" }} display="flex" flexDirection="column" alignContent="center">
            <Typography variant="h5" mb={10}>Admin</Typography>
            <Box sx={{ flexGrow: 1, minHeight: 0}}>
                <DataGrid
                autoPageSize
                columns={columns}
                rows={users}
                getRowId={row=>row.id}
                rowHeight={70}
                loading={isLoading}
                slots={{
                    toolbar: GridToolbar,
                }}
                slotProps={{
                    loadingOverlay: {
                    variant: 'skeleton',
                    noRowsVariant: 'skeleton',
                    },
                }}
                />
            </Box>
        </Box>
    );
  }
  
  export default AdminIndex;